export default __webpack_public_path__ + "static/media/skull.ef60df90.svg";